import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { useSearchParams } from "react-router-dom";
import './modal.css';
import '../../common/css/pw_push5.css';
import UploadIcon from '../../../images/icon_upload.gif';
import PearsonLogo from '../../../images/pearson_logo.png';
import ProgressBarGif from '../../../images/prog_bar.gif';
import ProgressBarTopGif from '../../../images/prog_top.gif';
import ProgressBarLeftGif from '../../../images/prog_left.gif';
import { SOCKET_ENDPOINT } from '../../utils/Constants'
import apiService from '../../utils/apiService';
import _ from "lodash";
import {
  buildUploadConflictState,
  getUploadableFiles,
} from './bulkUploadConflictUtils';
import {
  buildSoftDeletedConflictKey,
  buildSuccessFileTableRows,
  buildZipContentsFromUploadFiles,
  checkFileAndFolderExistence,
  collectUploadSpaceViolations,
  createUploadWebSocketMessageHandler,
  executeBulkUploadStart,
  filterInfectedFileRows,
  formatUploadElapsedTime,
  getBatchUploadAlert,
  getPhpRestrictionViolationMessage,
  hasUploadConflictMarkers,
  mapReplaceConflictsToExemptNames,
  partitionPhpRestrictedPaths,
  readFileInChunks,
  removeSpaceViolatingUploadFiles,
  resolveFilesToUpload,
  sendWebSocketIfOpen,
  UPLOAD_FILENAME_SPACE_MESSAGE,
  UPLOAD_ZIP_MANIFEST_REQUIRED_MESSAGE,
  validateUploadBatch,
} from './bulkUploadHelpers';

const getBaseName = (value) => {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  const lastSlash = Math.max(trimmed.lastIndexOf('/'), trimmed.lastIndexOf('\\'));
  return lastSlash >= 0 ? trimmed.slice(lastSlash + 1) : trimmed;
};

const stripLeadingDotsAndSlashes = (value) => {
  if (!value || typeof value !== 'string') return '';
  let index = 0;
  while (index < value.length) {
    const char = value[index];
    if (char === '.' || char === '/' || char === '\\') {
      index += 1;
    } else {
      break;
    }
  }
  return value.slice(index);
};


const BulkUploadPopup = props => {
  const [filesfound, setfilesfound] = useState(true);
  const modalRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [apiExistingConflicts, setApiExistingConflicts] = useState([]);
  const [apiSoftDeletedConflicts, setApiSoftDeletedConflicts] = useState([]);
  const validationRunRef = useRef(0);
  const pendingUploadModeRef = useRef(null);
  const pendingConflictStateRef = useRef(null);
  const uploadRunInFlightRef = useRef(false);
  const wsRef = useRef(null);
  const uploadProgressRef = useRef('0%');
  const displayFileSectionRef = useRef(false);
  const lastConflictStateRef = useRef(null);
  const [showSoftDeletedNotice, setShowSoftDeletedNotice] = useState(false);
  const softDeleteNoticeAcknowledgedForRef = useRef('');
  const [showFilenameSpaceNotice, setShowFilenameSpaceNotice] = useState(false);
  const [filenameSpaceNoticeMessage, setFilenameSpaceNoticeMessage] = useState(
    UPLOAD_FILENAME_SPACE_MESSAGE
  );
  const [filenameSpaceViolatingNames, setFilenameSpaceViolatingNames] = useState([]);
  const [filenameSpaceViolatingDirectories, setFilenameSpaceViolatingDirectories] = useState([]);
  const [filenameSpaceViolatingFiles, setFilenameSpaceViolatingFiles] = useState([]);
  const [managedFiles, setManagedFiles] = useState(null);

  let divStyle = {
    display: props.displayModal ? 'block' : 'none',
    overflowY: "auto"

  };
  let [searchParams, setSearchParams] = useSearchParams();
  function closeModal(e) {
    console.log("closeModal--------------");
    e.stopPropagation();
    softDeleteNoticeAcknowledgedForRef.current = '';
    pendingUploadModeRef.current = null;
    pendingConflictStateRef.current = null;
    uploadRunInFlightRef.current = false;
    lastConflictStateRef.current = null;
    setShowSoftDeletedNotice(false);
    setShowFilenameSpaceNotice(false);
    setFilenameSpaceNoticeMessage(UPLOAD_FILENAME_SPACE_MESSAGE);
    setFilenameSpaceViolatingNames([]);
    setFilenameSpaceViolatingDirectories([]);
    setFilenameSpaceViolatingFiles([]);
    setManagedFiles(null);
    props.onModalPopupStateChange(props.displayModal, e);
    if (searchParams.has('bulkupload')) {
      searchParams.delete('bulkupload');
      setSearchParams(searchParams);
      //dispatch(resetAppState({message:""}));
    }
  }

  const { acceptedFiles: dropzoneFiles, getRootProps, getInputProps } = useDropzone(
    {
      multiple: true,
      directory: true,
      onDrop: (files) => setManagedFiles(files),
    }
  );
  const acceptedFiles = managedFiles ?? dropzoneFiles;

  let [uploadProgress, setUploadProgressState] = useState('0%');
  const setUploadProgress = (value) => {
    uploadProgressRef.current = value;
    setUploadProgressState(value);
  };
  const [ws, setWs] = useState(null);
  let [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const startTimeRef = useRef(startTime);
  let [netSpeed, setNetSpeed] = useState(0);
  let [ibytes, setIbytes] = useState(0);
  let [itotal, setITotal] = useState(0);
  let [fileUploadStartTime, setFileUploadStartTime] = useState('');
  let ibytesRef = useRef(ibytes);
  let [wsTransmittedReceivedData, setWsTransmittedReceivedData] = useState(0);
  let wsTransmittedReceivedDataRef = useRef(wsTransmittedReceivedData);
  let [displayFileSection, setDisplayFileSectionState] = useState(false);
  const setDisplayFileSection = (value) => {
    displayFileSectionRef.current = value;
    setDisplayFileSectionState(value);
  };
  let [successFileTableData, setSuccessFileTableData] = useState([])
  const [message, setMessage] = useState('');
  const [virusFile,setVirusFile]=  useState('');
  const [filescan, setFilescan] = useState([]);
  const [displayVirusMessage, setDisplayVirusMessage] = useState([]);
  const [filesDeleted, setFilesDeleted] = useState(false);
  const [filesUploaded, setFilesUploaded] = useState(false);
  const [filteredFiles, setFilteredFiles] = useState([]);




  const fetchFileScanAccess = async () => {
    try {
      const response = await apiService.get("getfilescan");
      const data = _.get(response, 'data', []);

      setFilescan(data); //  Update state
    } catch (error) {
      console.error("Error fetching file scan access:", error);
      setMessage("Error loading data.");
    }
  };

  // Load data on component mount
  useEffect(() => {
    let count = 0;

    const interval = setInterval(() => {
      if (count < 6) {
        fetchFileScanAccess();
        count++;
      } else {
        clearInterval(interval);
      }
    }, 1000); // Calls every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);


  const attachUploadWebSocketHandlers = (newWs) => {
    newWs.addEventListener('open', function () {
      console.log('Connected to the WebSocket server');
    });

    newWs.addEventListener('message', function (event) {
      const data = JSON.parse(event.data);

      if (data.topic === 'scan-result' && data.status === 'infected') {
        console.warn('Virus Detected:', data.message);
        setDisplayVirusMessage(data.message);
        setVirusFile(data.infectedFile);
      }
    });

    newWs.onopen = () => {
      console.log('Connected to WebSocket');
      newWs.send(JSON.stringify({ type: 'fileScanData', data: filescan }));
    };

    newWs.onmessage = (event) => {
      console.log('Message from server:', event.data);
    };
  };

  const connectUploadWebSocket = () => {
    const newWs = new WebSocket(`${SOCKET_ENDPOINT}socket/`);
    attachUploadWebSocketHandlers(newWs);
    wsRef.current = newWs;
    setWs(newWs);
    return newWs;
  };

  const waitForUploadWebSocketOpen = (activeWs, timeoutMs = 10000) =>
    new Promise((resolve, reject) => {
      if (!activeWs) {
        reject(new Error('WebSocket is not available'));
        return;
      }
      if (activeWs.readyState === WebSocket.OPEN) {
        resolve(activeWs);
        return;
      }
      if (activeWs.readyState !== WebSocket.CONNECTING) {
        reject(new Error('WebSocket is not open'));
        return;
      }

      const onOpen = () => {
        clearTimeout(timer);
        activeWs.removeEventListener('open', onOpen);
        resolve(activeWs);
      };

      const timer = setTimeout(() => {
        activeWs.removeEventListener('open', onOpen);
        reject(new Error('WebSocket connection timeout'));
      }, timeoutMs);

      activeWs.addEventListener('open', onOpen);
    });

  const ensureUploadWebSocketReady = async () => {
    try {
      const existingWs = wsRef.current;
      if (existingWs && existingWs.readyState === WebSocket.OPEN) {
        return true;
      }

      const activeWs = connectUploadWebSocket();
      await waitForUploadWebSocketOpen(activeWs);
      return true;
    } catch (error) {
      console.error('Failed to connect upload WebSocket:', error);
      setMessage('Upload connection is not ready. Please wait a moment and try again.');
      return false;
    }
  };

  // WebSocket connection on mount (upload flow + virus scan messages)
  useEffect(() => {
    connectUploadWebSocket();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, []);

  // Wait for filescan to be updated, then send it to WebSocket
  useEffect(() => {
    if (filescan && ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: "fileScanData", data: filescan }));
    }
  }, [filescan, ws]);

  const isWebSocketReady = () =>
    wsRef.current && wsRef.current.readyState === WebSocket.OPEN;

  const resetStalledUploadUi = (conflictState) => {
    setUploadProgress('0%');
    setIbytes(0);
    setWsTransmittedReceivedData(0);
    wsTransmittedReceivedDataRef.current = 0;
    ibytesRef.current = 0;
    setfilesfound(hasUploadConflictMarkers(conflictState));
  };

  const sendFileInChunks = (file, index, filesToUpload = []) => {
    if (!isWebSocketReady()) {
      console.error('WebSocket is not open or is not available.');
      resetStalledUploadUi(lastConflictStateRef.current);
      setMessage('Upload connection is not ready. Please try again.');
      return;
    }

    const activeWs = wsRef.current;
    sendWebSocketIfOpen(activeWs, JSON.stringify({ type: 'fileScanData', data: filescan }));
    activeWs.onmessage = createUploadWebSocketMessageHandler({
      onInfectedFile: (infectedFile) => {
        setSuccessFileTableData((prevRows) => filterInfectedFileRows(prevRows, infectedFile));
      },
      onTime: (time) => {
        startTimeRef.current = time;
        setFileUploadStartTime(time);
      },
      onProgress: (data) => {
        wsTransmittedReceivedDataRef.current = data;
        setWsTransmittedReceivedData(wsTransmittedReceivedDataRef.current);
        const elapsed = (Date.now() - parseFloat(startTimeRef.current)) / 1000;
        setElapsedTime(elapsed);
        console.log('wsTransmittedReceivedData (cumulative):', wsTransmittedReceivedDataRef.current);
      },
    });

    sendStartMessage(file);
    readFileInChunks({
      file,
      onChunkRead: ({ chunk, loaded }) => {
        ibytesRef.current += loaded;
        setIbytes(ibytesRef.current);
        activeWs.send(chunk);
      },
      onComplete: () => {
        sendEndMessage(file);
        const nextIndex = index + 1;
        if (filesToUpload.length > nextIndex) {
          sendFileInChunks(filesToUpload[nextIndex], nextIndex, filesToUpload);
        }
      },
    });
  };

  const sendPath = () => {
    const activeWs = wsRef.current;
    sendWebSocketIfOpen(activeWs, `${props.currentDir} Bulk_Upload_path`);
    sendWebSocketIfOpen(activeWs, `${props.currentDir} Bulk_Upload_path`);
    sendWebSocketIfOpen(
      activeWs,
      JSON.stringify({ type: 'fileScanData', data: filescan?.data || filescan })
    );
  };

  const handleContinueUpload = () => {
    // Remove eicar and any virus file by matching basename
    const pruned = files.filter(file => {
      const base = getBaseName(file.key);
      const virusBase = getBaseName(virusFile);
      return base !== virusBase;
    });
    console.log('filteredFiles,', virusFile, pruned);

    setFilteredFiles(pruned);
    const rows = pruned.map((file, idx) => {
      const displayKey = stripLeadingDotsAndSlashes(file.key);
      const parts = Array.isArray(file.props.children) ? file.props.children : [];
      const size = parts[2] || '';
      return (
        <tr key={idx}>
          <td style={{ border: '1px solid black' }}>{displayKey}</td>
          <td style={{ border: '1px solid black' }}>{size}</td>
        </tr>
      );
    });
    setSuccessFileTableData(rows);

    setDisplayVirusMessage([]);
    setFilesUploaded(true);
  };

  const sendStartMessage = (file) => {
    const activeWs = wsRef.current;
    sendWebSocketIfOpen(activeWs, `${file.path} Bulk_Upload_starts`);
    sendWebSocketIfOpen(
      activeWs,
      JSON.stringify({ type: 'fileScanData', data: filescan?.data || filescan })
    );
  };

  const handleDeleteFiles = () => {
    const activeWs = wsRef.current;
    if (activeWs && activeWs.readyState === WebSocket.OPEN) {
      activeWs.send(JSON.stringify({ type: 'deleteFiles' }));
      console.log('Sent "deleteFiles" command to server.');
    }
    setFilesDeleted(true);
  };

  const sendEndMessage = (file) => {
    sendWebSocketIfOpen(wsRef.current, `${file.path} Bulk_Upload_ends`);
  };

  const validateSelectionConflicts = async (selectedPaths, selectedFiles) => {
    if (!selectedPaths || selectedPaths.length === 0) {
      setApiExistingConflicts([]);
      setApiSoftDeletedConflicts([]);
      setfilesfound(false);
      return { replaceConflicts: [], softDeletedConflicts: [] };
    }

    const payload = {
      currentpath: props.currentDir,
      filename: selectedPaths[0],
      uploadPaths: selectedPaths
    };

    const zipContents = await buildZipContentsFromUploadFiles(selectedFiles || []);
    if (Object.keys(zipContents).length > 0) {
      payload.zipContents = zipContents;
    }

    setMessage('');

    let validationResponse;
    try {
      validationResponse = await apiService.post("fileupload", payload);
    } catch (error) {
      console.error("Error validating upload duplicates:", error);
      setMessage("Error validating upload duplicates.");
      return null;
    }

    const statusCode = validationResponse?.status || validationResponse?.data?.status_code;
    if (statusCode === 400) {
      const manifestMessage = validationResponse?.data?.message
        || UPLOAD_ZIP_MANIFEST_REQUIRED_MESSAGE;
      showPhpRestrictionNoticeFromValidation([], manifestMessage);
      setfilesfound(false);
      return null;
    }

    if (statusCode === 403) {
      const restrictedPaths = _.get(validationResponse, 'data.data.phpRestrictedPaths', []);
      const policyMessage = validationResponse?.data?.message
        || getPhpRestrictionViolationMessage(restrictedPaths);
      showPhpRestrictionNoticeFromValidation(restrictedPaths, policyMessage);
      setfilesfound(false);
      return null;
    }

    if (statusCode && statusCode !== 200) {
      const validationMessage = validationResponse?.data?.message
        || `Upload validation failed (${statusCode || 'unknown'}).`;
      setMessage(validationMessage);
      setApiExistingConflicts([]);
      setApiSoftDeletedConflicts([]);
      setfilesfound(false);
      return null;
    }

    const nextApiExistingConflicts = _.get(validationResponse, "data.data.existingConflicts", []);
    const nextApiSoftDeletedConflicts = _.get(validationResponse, "data.data.softDeletedConflicts", []);
    const localConflicts = checkFileAndFolderExistence(
      selectedFiles,
      localStorage.getItem('directories')
    );
    const nextConflictState = buildUploadConflictState({
      apiExistingConflicts: nextApiExistingConflicts,
      apiSoftDeletedConflicts: nextApiSoftDeletedConflicts,
      localConflicts
    });

    setApiExistingConflicts(nextApiExistingConflicts);
    setApiSoftDeletedConflicts(nextApiSoftDeletedConflicts);
    setfilesfound(
      nextConflictState.replaceConflicts.length > 0 ||
      nextConflictState.softDeletedConflicts.length > 0
    );

    return nextConflictState;
  };

  const showSoftDeletedBlockedNotice = () => {
    softDeleteNoticeAcknowledgedForRef.current = '';
    setShowSoftDeletedNotice(true);
  };

  const showFilenameSpaceNoticeFromValidation = (spaceValidation, mode, conflictState) => {
    pendingUploadModeRef.current = mode;
    pendingConflictStateRef.current = conflictState;
    setFilenameSpaceViolatingNames(spaceValidation.violatingNames || []);
    setFilenameSpaceViolatingDirectories(spaceValidation.violatingDirectories || []);
    setFilenameSpaceViolatingFiles(spaceValidation.violatingFiles || []);
    setFilenameSpaceNoticeMessage(
      spaceValidation.message || UPLOAD_FILENAME_SPACE_MESSAGE
    );
    setShowFilenameSpaceNotice(true);
  };

  const showPhpRestrictionNoticeFromValidation = (restrictedPaths, messageOverride) => {
    pendingUploadModeRef.current = null;
    pendingConflictStateRef.current = null;
    const { files } = partitionPhpRestrictedPaths(restrictedPaths);
    setFilenameSpaceViolatingNames([]);
    setFilenameSpaceViolatingDirectories([]);
    setFilenameSpaceViolatingFiles(files);
    setFilenameSpaceNoticeMessage(
      messageOverride || getPhpRestrictionViolationMessage(restrictedPaths)
    );
    setShowFilenameSpaceNotice(true);
  };

  const proceedWithValidatedUpload = async (filesToUpload, conflictState, mode, options = {}) => {
    const { skipSpaceValidation = false } = options;
    if (!skipSpaceValidation) {
      const spaceValidation = await collectUploadSpaceViolations(
        filesToUpload,
        mapReplaceConflictsToExemptNames(conflictState.replaceConflicts)
      );
      if (!spaceValidation.valid) {
        showFilenameSpaceNoticeFromValidation(spaceValidation, mode, conflictState);
        return;
      }
    }

    if (!isWebSocketReady()) {
      setMessage('Upload connection is not ready. Please wait a moment and try again.');
      return;
    }

    setSuccessFileTableData(buildSuccessFileTableRows(filesToUpload));

    const batchValidation = validateUploadBatch(filesToUpload, []);
    const batchAlert = getBatchUploadAlert(batchValidation);
    if (batchAlert) {
      alert(batchAlert.message);
      if (batchAlert.clearFilesFound) {
        setfilesfound(false);
      }
      return;
    }

    lastConflictStateRef.current = conflictState;
    pendingConflictStateRef.current = null;
    executeBulkUploadStart({
      filesToUpload,
      batchValidation,
      sendPath,
      sendStartMessage,
      sendEndMessage,
      sendFileInChunks,
      setUploadProgress,
      setDisplayFileSection,
      setITotal,
      setfilesfound,
    });
  };

  const runUploadForSelection = async (selectedFiles, mode) => {
    if (uploadRunInFlightRef.current) {
      return;
    }

    const selectedPaths = selectedFiles.map((file) => file.path).filter(Boolean);
    if (!selectedPaths.length) {
      return;
    }

    uploadRunInFlightRef.current = true;
    setMessage('');

    try {
      const wsReady = await ensureUploadWebSocketReady();
      if (!wsReady) {
        return;
      }

      const conflictState = await validateSelectionConflicts(selectedPaths, selectedFiles);
      if (!conflictState) {
        return;
      }

      if (hasUploadConflictMarkers(conflictState)) {
        setfilesfound(true);
      }

      const isStalledUploadAttempt =
        !displayFileSectionRef.current &&
        wsTransmittedReceivedDataRef.current === 0 &&
        ibytesRef.current === 0 &&
        uploadProgressRef.current !== '0%';

      if (isStalledUploadAttempt) {
        resetStalledUploadUi(conflictState);
      }

      const uploadResolution = resolveFilesToUpload({
        conflictState,
        mode,
        acceptedFiles: selectedFiles,
      });

      const spaceValidationTargets = getUploadableFiles({
        acceptedFiles: selectedFiles,
        replaceConflicts: conflictState.replaceConflicts,
        softDeletedConflicts: conflictState.softDeletedConflicts,
        mode,
      });
      if (spaceValidationTargets.length > 0) {
        const spaceValidation = await collectUploadSpaceViolations(
          spaceValidationTargets,
          mapReplaceConflictsToExemptNames(conflictState.replaceConflicts)
        );
        if (!spaceValidation.valid) {
          showFilenameSpaceNoticeFromValidation(
            spaceValidation,
            mode,
            conflictState
          );
          return;
        }
      }

      if (!uploadResolution || uploadResolution.shouldAbort) {
        if (
          mode === 'replace' &&
          conflictState.softDeletedConflicts.length > 0
        ) {
          showSoftDeletedBlockedNotice();
        }
        return;
      }

      await proceedWithValidatedUpload(
        uploadResolution.filesToUpload,
        conflictState,
        mode,
        { skipSpaceValidation: true }
      );
    } finally {
      uploadRunInFlightRef.current = false;
    }
  };

  const handleFileUpload = async (e, mode = 'upload') => {
    e.preventDefault();
    pendingUploadModeRef.current = mode;
    await runUploadForSelection(acceptedFiles, mode);
  };

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const formatTime = formatUploadElapsedTime;
  useEffect(() => {
    if (wsTransmittedReceivedData !== undefined && itotal > 0) {

      let uploadPercentage = ((wsTransmittedReceivedData / itotal) * 100).toFixed(2) + '%';
      setUploadProgress(uploadPercentage);

      if (parseFloat(uploadPercentage) === 100) {
        setDisplayFileSection(true);
      }

      // Ensure elapsedTime is not zero to avoid division by zero
      let bSpeed = elapsedTime > 0 ? (wsTransmittedReceivedData / elapsedTime) : 0;
      let bitSpeed = bSpeed * 8; // Convert bytes/sec to bits/sec
      let kbitSpeed = (bitSpeed / 1000).toFixed(2); // Convert to kilobits/sec
      // Ensure valid speed values before updating state
      setNetSpeed(isNaN(kbitSpeed) ? 0 : kbitSpeed);

      let bytesRemaining = itotal - wsTransmittedReceivedData;
      let dtRemaining = kbitSpeed > 0 ? (bytesRemaining / (kbitSpeed * 1000)) : 0; // Avoid NaN
      setTimeRemaining(Math.trunc(dtRemaining));
    }
  }, [itotal, wsTransmittedReceivedData, elapsedTime]);

  if (files) {
    files.forEach(file => console.log("files::::", file.key));

  }
  const localConflicts = checkFileAndFolderExistence(
    acceptedFiles,
    localStorage.getItem('directories')
  );
  const { replaceConflicts, softDeletedConflicts } = buildUploadConflictState({
    apiExistingConflicts,
    apiSoftDeletedConflicts,
    localConflicts
  });
  const hasReplaceConflicts = replaceConflicts.length > 0;
  const hasSoftDeletedConflicts = softDeletedConflicts.length > 0;
  const hasAnyConflicts = hasReplaceConflicts || hasSoftDeletedConflicts;
  const hasUploadableFiles = getUploadableFiles({
    acceptedFiles,
    replaceConflicts,
    softDeletedConflicts,
    mode: 'upload'
  }).length > 0;

  const shouldShowCancelOnly = filesfound && 
    !hasReplaceConflicts && 
    hasSoftDeletedConflicts && 
    !hasUploadableFiles;

  const selectedFilesKey = useMemo(
    () => buildSoftDeletedConflictKey(acceptedFiles.map((file) => file.path)),
    [acceptedFiles]
  );

  useEffect(() => {
    if (!props.displayModal) {
      softDeleteNoticeAcknowledgedForRef.current = '';
      setShowSoftDeletedNotice(false);
      return;
    }
    if (!filesfound || !hasSoftDeletedConflicts || !selectedFilesKey) {
      if (!hasSoftDeletedConflicts) {
        softDeleteNoticeAcknowledgedForRef.current = '';
      }
      setShowSoftDeletedNotice(false);
      return;
    }
    if (selectedFilesKey === softDeleteNoticeAcknowledgedForRef.current) {
      setShowSoftDeletedNotice(false);
      return;
    }
    setShowSoftDeletedNotice(true);
  }, [props.displayModal, filesfound, hasSoftDeletedConflicts, selectedFilesKey]);

  const handleSoftDeletedNoticeOk = (e) => {
    e.preventDefault();
    e.stopPropagation();
    softDeleteNoticeAcknowledgedForRef.current = selectedFilesKey;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setShowSoftDeletedNotice(false);
      });
    });
  };

  const handleFilenameSpaceNoticeOk = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const conflictStateForExempt =
      pendingConflictStateRef.current || { replaceConflicts };
    const remainingFiles = await removeSpaceViolatingUploadFiles(
      acceptedFiles,
      mapReplaceConflictsToExemptNames(conflictStateForExempt.replaceConflicts)
    );
    setManagedFiles(remainingFiles);
    softDeleteNoticeAcknowledgedForRef.current = buildSoftDeletedConflictKey(
      remainingFiles.map((file) => file.path)
    );
    setFilenameSpaceNoticeMessage(UPLOAD_FILENAME_SPACE_MESSAGE);
    setFilenameSpaceViolatingNames([]);
    setFilenameSpaceViolatingDirectories([]);
    setFilenameSpaceViolatingFiles([]);
    pendingUploadModeRef.current = null;
    pendingConflictStateRef.current = null;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setShowFilenameSpaceNotice(false);
      });
    });
  };

  const handleFilenameSpaceNoticeCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    pendingUploadModeRef.current = null;
    pendingConflictStateRef.current = null;
    softDeleteNoticeAcknowledgedForRef.current = '';
    setApiExistingConflicts([]);
    setApiSoftDeletedConflicts([]);
    setfilesfound(false);
    setManagedFiles([]);
    setShowFilenameSpaceNotice(false);
    setFilenameSpaceNoticeMessage(UPLOAD_FILENAME_SPACE_MESSAGE);
    setFilenameSpaceViolatingNames([]);
    setFilenameSpaceViolatingDirectories([]);
    setFilenameSpaceViolatingFiles([]);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setShowFilenameSpaceNotice(false);
      });
    });
  };

  useEffect(() => {
    const selectedPaths = acceptedFiles.map((file) => file.path).filter(Boolean);
    const runId = validationRunRef.current + 1;
    validationRunRef.current = runId;

    if (!selectedPaths.length) {
      setApiExistingConflicts([]);
      setApiSoftDeletedConflicts([]);
      setfilesfound(false);
      return;
    }

    (async () => {
      try {
        const result = await validateSelectionConflicts(selectedPaths, acceptedFiles);
        if (validationRunRef.current !== runId) {
          return;
        }
        if (!result) {
          return;
        }
      } catch (error) {
        console.error('Upload selection validation failed:', error);
      }
    })();
  }, [acceptedFiles, props.currentDir]);

  const handleMouseDown = (e) => {
    const rect = modalRef.current.getBoundingClientRect();
    setIsDragging(true);
    setOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const modal = modalRef.current;
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;
    const modalRect = modal.getBoundingClientRect();
    let newLeft = e.clientX - offset.x;
    let newTop = e.clientY - offset.y;
    if (newLeft < 0) newLeft = 0;
    if (newTop < 0) newTop = 0;
    if (newLeft + modalRect.width > containerWidth) newLeft = containerWidth - modalRect.width;
    if (newTop + modalRect.height > containerHeight) newTop = containerHeight - modalRect.height;
    modal.style.left = `${newLeft}px`;
    modal.style.top = `${newTop}px`;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };


  return (
    <>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div ref={modalRef} className="modal-content" onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}
        style={{ position: "absolute", height: "550px", width: "640px", backgroundColor: "white", border: "1px solid black", borderRadius: "20px", cursor: isDragging ? "grabbing" : "grab" }}>

        <div style={{ display: displayFileSection ? 'none' : 'block', overflowY: "auto" }}>

          <table role="presentation" border="0" width="100%" cellSpacing="3" cellPadding="0" className='modal-content-table'>
            <tr align="left" valign="top">
              <td align="left" valign="middle"><span className="pagetitle">&nbsp;Bulk File Uploader</span></td>
              <td align="right" valign="middle"><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education"
                width="85" height="21" hspace="0" vspace="0" border="0" /></td>
              <td><span
                className="close" onClick={closeModal}
              >&times;
              </span>
              </td></tr>
          </table>

          <div id="table" style={{ position: "absolute", top: "46px", width: "550px", height: "120px", zIndex: "1" }}>
            <table role="presentation" align="center" border="0" width="" cellSpacing="0" cellPadding="0">
              <tr align="left" valign="top">
                <td align="left" valign="top" width="90" style={{ backgroundcolor: "#E9EAEC" }}><img src={UploadIcon} alt="Upload Files" width="91" height="70" hspace="0" vspace="0" border="0" /></td>
                <td align="center" valign="middle" className="instructions">You may upload file of any size. <br /><br />
                  File(s) uploaded will be located in the following directory:<br />
                  <font style={{ color: 'red' }}>
                    {decodeURIComponent(props.currentDir)}
                  </font>
                  <br /><br />
                  <div onSubmit={handleFileUpload} style={{ overflowY: "auto" }}>
                    <div {...getRootProps()} style={dropzoneStyle}>
                      <input {...getInputProps()} />
                      <p>Drag and drop some files here, or
                        <span style={{ color: 'red' }}> click</span> to select files</p>
                      <aside>
                        <h4>Files</h4>
                        <ul>{files}</ul>
                      </aside>

                    </div>

                    {message ? (
                      <div
                        className="upload-folder-ErrorMsg"
                        role="alert"
                        style={{ color: 'red', marginTop: '8px', whiteSpace: 'pre-line' }}
                      >
                        {message}
                      </div>
                    ) : null}

                    <div>
                      {filesfound && hasReplaceConflicts ?
                        <h4>
                          <span style={{ color: "black" }}>List of uploaded files/folder already exist in the following directory:</span>
                          <br />
                          <span style={{ color: "red" }}>"{decodeURIComponent(props.currentDir)}"</span>
                        </h4>
                        : ""}
                    </div>


                    {filesfound && hasReplaceConflicts ?
                      <div style={rewriteUploadStyle}>
                        <table role="presentation" border="0" width="100%" height="50px" cellSpacing="0" cellPadding="0" >
                          <tr align="center">
                            <div >
                              <td >
                                <span className='upload-folder-ErrorMsg'>
                                  <aside>
                                    <ul >
                                      {replaceConflicts.map((file, index) => (
                                        <li key={index}>{file}</li>
                                      ))}
                                    </ul>
                                  </aside>
                                  <br />
                                </span>
                              </td>
                            </div>
                          </tr>
                        </table>
                      </div> : ""}
                    <br />
                    {uploadProgress != '0%' &&
                      <table role="presentation" style={{ border: '0', width: '100%', backgroundColor: "#E9EAEC", marginTop: "50px" }}>

                        {wsTransmittedReceivedData < itotal &&

                          (<tr align="center" style={{ verticalAlign: "top" }}>
                            <td align="center" style={{ verticalAlign: "middle" }} className="pagetitle" colSpan="2">File Upload in Progress, Please don't close window</td>
                          </tr>)
                        }

                        {wsTransmittedReceivedData == itotal &&

                          (<tr align="center" style={{ verticalAlign: "top" }}>
                            <td align="center" style={{ verticalAlign: "middle" }} className="pagetitle" colSpan="2">File Upload is Completed</td>
                          </tr>)
                        }

                        <tr align="left" style={{ verticalAlign: "top" }} >
                          <td align="left" style={{ verticalAlign: "middle" }} colSpan="2">

                            <table role="presentation" summary="This table displays the progress bar" border="0" width='100%' cellSpacing="0" cellPadding="0" background-color="#FFFFFF">
                              <tr align="left" style={{ verticalAlign: "top" }}>
                                <td align="left" style={{ verticalAlign: "top", paddingTop: "13px" }} rowSpan="3" width="3"><img src={ProgressBarLeftGif} alt="" width="3" height="16" hspace="0" vspace="0" border="0" colSpan="2" /></td>
                                <td align="left" style={{ verticalAlign: "top" }}><img src={ProgressBarTopGif} alt="" width={uploadProgress} height="4" hspace="0" vspace="0" border="0" style={{ marginBottom: "-5px" }} /></td>
                              </tr>

                              <tr align="left" style={{ verticalAlign: "top" }}>
                                <td align="left" style={{ verticalAlign: "top" }}><span><img src={ProgressBarGif} alt="" width={uploadProgress} height="10" hspace="0" vspace="0" border="0" /></span>

                                </td>
                              </tr>

                              <tr align="center" style={{ verticalAlign: "top" }}>
                                <td align="center" style={{ verticalAlign: "middle" }} className="instructions" colSpan="2">Status: {wsTransmittedReceivedData} bytes of {itotal} sent (at {netSpeed} Kbps)</td>
                              </tr>

                            </table>
                            <table role="presentation" border="0" width='100%' cellSpacing="0" cellPadding="0" >
                              <tr align="center" verticalAlign="top">
                                <td align="left" style={{ verticalAlign: "middle" }} className="instructions"><strong>Est Time left:&nbsp;</strong>{formatTime(timeRemaining)}</td>
                                <td align="right" style={{ verticalAlign: "middle" }} className="instructions"><strong>Elapsed time:&nbsp;</strong>{formatTime(elapsedTime)}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>

                      </table>
                    }
                    <br />
                    {message ? (
                      <p className="upload-folder-ErrorMsg" role="alert" style={{ textAlign: 'center' }}>
                        {message}
                      </p>
                    ) : null}
                    <br />
                  </div>
                  {filesfound && hasReplaceConflicts ? (
                    <span style={{ paddingBottom: "30px" }}>
                      <button type="button" className="close_button" style={{ margin: "5px" }} onClick={closeModal}>
                        Cancel
                      </button>
                      <button
                        type="submit"
                        style={{ margin: "5px", marginLeft: "30px" }}
                        disabled={showSoftDeletedNotice || showFilenameSpaceNotice}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleFileUpload(event, 'replace');
                        }}
                      >
                        Replace Files
                      </button>
                    </span>
                  ) : shouldShowCancelOnly ? (
                    <span style={{ paddingBottom: "30px" }}>
                      <button type="button" className="close_button" style={{ margin: "5px" }} onClick={closeModal}>
                        Cancel
                      </button>
                    </span>
                  ) : (
                    <button
                      type="submit"
                      style={{ margin: "5px" }}
                      disabled={showSoftDeletedNotice || showFilenameSpaceNotice}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleFileUpload(event, 'upload');
                      }}
                    >
                      Upload Files
                    </button>
                  )}
                </td>
              </tr>
            </table>

          </div>
        </div>
        {displayVirusMessage.length > 0 ?
          <div style={{ display: displayFileSection ? 'block' : 'none', fontSize: '110%', fontFamily: "inherit", position: "relative", width: "100%", height: "100%", overflow: "scroll" }}>
            <table role="presentation" border="0" width="100%" cellSpacing="3" cellPadding="0" className='modal-content-table'>
              <tr align="left" valign="top">
                <td align="left" valign="middle"><span className="pagetitle">&nbsp;Virus Files</span></td>
                <td align="right" valign="middle"><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education"
                  width="85" height="21" hspace="0" vspace="0" border="0" /></td>
                <td><span
                  className="close" onClick={closeModal}
                >&times;
                </span>
                </td></tr>
            </table>
            <div className="mb-4">{displayVirusMessage}  </div>
            {filesDeleted ? (
              <div div style={{ color: "green", fontWeight: "bold", paddingLeft: '10px' }}>
                <p>All files have been deleted.</p>
              </div>

            ) : filesUploaded ? (
              <div style={{ padding: '10px', textAlign: 'center' }}>
                <p>All files have been uploaded.</p>
                <button onClick={closeModal} style={{ padding: '5px', marginTop: '10px' }}>Close</button>
              </div>
            ) : (
              <div style={{ margin: "10px" }} >
                <button
                  onClick={handleDeleteFiles}
                  className="close_button"
                  style={{ padding: "5px", marginRight: "20px" }}
                >
                  Delete All Files
                </button>
                <button onClick={handleContinueUpload} className="close_button" style={{ padding: "5px" }}>
                  Continue Upload
                </button>
              </div>
            )}

          </div>
          :
          <div style={{ display: displayFileSection ? 'block' : 'none', fontSize: '110%', fontFamily: "inherit", position: "relative", width: "100%", height: "100%", overflow: "scroll" }}>
            <table style={{ border: "1px solid black", cellPadding: "5", width: "95%", align: "center", marginLeft: "auto", marginRight: "auto", marginTop: "25px" }}>

              <thead>
                <tr>
                  <th colSpan="2" scope="colgroup" style={{ backgroundColor: "#0066cc" }}>
                    <font style={{ color: "white", size: "+1", align: "center" }}>Files Uploaded</font>
                  </th>
                </tr>

                <tr style={{ backgroundColor: "#CCCFF3" }}>
                  <th scope="col" style={{ fontSize: "110%", border: "1px solid black" }}>
                    <nobr>File Name</nobr>
                  </th>

                  <th scope="col" style={{ fontSize: "110%", align: "right", border: "1px solid black" }}>
                    <nobr>File size</nobr>
                  </th>
                </tr>
              </thead>
              <tbody>
              {successFileTableData}
              </tbody>
            </table>
            {/* <p> */}
            <center> <button onClick={closeModal} className="closeButton">close</button> </center>

            {/* </p> */}
            <div style={{ bottom: "30px", width: "100%", position: "static" }}>
              <hr />
              <table role="presentation" align="center">
                <tr><td align="center">File Upload Complete</td></tr>
                <tr>
                  <td>
                    Status: {ibytes} bytes of {itotal} sent (at {Math.abs(netSpeed)} Kbps)<br />
                    Est time left: 00:00:00<br />
                    Elapsed time: {Math.abs(elapsedTime)}<br />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        }
      </div>
    </div >
    {props.displayModal && showSoftDeletedNotice && filesfound && hasSoftDeletedConflicts ? (
      <div
        className="bulk-upload-soft-delete-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bulk-upload-soft-delete-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="bulk-upload-soft-delete-dialog" onMouseDown={(e) => e.stopPropagation()}>
          <div className="soft-delete-duplicate-msg">
            <h4 id="bulk-upload-soft-delete-title">
              <span>
                These items cannot be uploaded/replaced because they already exist in the soft deleted list in the following directory. To upload or replace them, restore the file/folder first and then try again:
              </span>
              <br />
              <span>&quot;{decodeURIComponent(props.currentDir)}&quot;</span>
            </h4>
            <div style={rewriteUploadStyle}>
              <table role="presentation" border="0" width="100%" height="50px" cellSpacing="0" cellPadding="0">
                <tbody>
                  <tr align="center">
                    <td>
                      <span className="upload-folder-ErrorMsg">
                        <aside>
                          <ul>
                            {softDeletedConflicts.map((name, index) => (
                              <li key={`soft-overlay-${index}`}>{name}</li>
                            ))}
                          </ul>
                        </aside>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="bulk-upload-soft-delete-actions">
            <button
              type="button"
              className="close_button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={handleSoftDeletedNoticeOk}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    ) : null}
    {props.displayModal && showFilenameSpaceNotice ? (
      <div
        className="bulk-upload-soft-delete-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bulk-upload-filename-space-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          className="bulk-upload-soft-delete-dialog bulk-upload-filename-space-dialog"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="instructions delete-folder-modal-main bulk-upload-filename-space-body">
            <div className="delete-folder-modal-copy-delete">
              <p className="delete-folder-note bulk-upload-filename-space-note">
                <strong>Note:</strong>{' '}
                <strong className="delete-folder-alert-text" id="bulk-upload-filename-space-title">
                  {filenameSpaceNoticeMessage}
                </strong>
              </p>
              <p className="delete-folder-path">
                <strong>Directory :</strong>
                <strong className="delete-folder-path-text">
                  {decodeURIComponent(props.currentDir).replace(/%20/g, ' ')}
                </strong>
              </p>
            </div>
            {(filenameSpaceViolatingDirectories.length > 0 ||
              filenameSpaceViolatingFiles.length > 0) ? (
              <div className="delete-folder-lists bulk-upload-filename-space-lists">
                {filenameSpaceViolatingDirectories.length > 0 ? (
                  <div className="bulk-upload-filename-space-column">
                    <h3 className="delete-folder-list-heading">Directory:</h3>
                    <ul className="delete-folder-list">
                      {filenameSpaceViolatingDirectories.map((name, index) => (
                        <li key={`space-directory-${index}`}>
                          <strong>
                            {index + 1}. {name}
                          </strong>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                {filenameSpaceViolatingFiles.length > 0 ? (
                  <div className="bulk-upload-filename-space-column">
                    <h3 className="delete-folder-list-heading">Files:</h3>
                    <ul className="delete-folder-list">
                      {filenameSpaceViolatingFiles.map((name, index) => (
                        <li key={`space-file-${index}`}>
                          <span style={{ fontWeight: 'bold' }}>
                            {index + 1}. {name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="delete-folder-actions">
              <input
                type="button"
                className="unzip-formButton"
                value="&nbsp;Cancel&nbsp;"
                onClick={handleFilenameSpaceNoticeCancel}
              />
              {/* OK removed from file/folder/ZIP space notices — cancel and fix names locally
              <input
                type="button"
                className="unzip-formButtonGo"
                value="&nbsp;&nbsp;OK&nbsp;&nbsp;"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={handleFilenameSpaceNoticeOk}
              />
              */}
            </div>
          </div>
        </div>
      </div>
    ) : null}
    </>
  );

}



const dropzoneStyle = {
  border: '2px dashed #cccccc',
  borderRadius: '4px',
  padding: '40px',
  textAlign: 'center',
  cursor: 'pointer',
  opacity: '0.7',
  boxShadow: '3px 3px 5px 0px rgba(0,0,0,0.3)',
  maxHeight: '100px',
  overflowY: 'auto',
};

const rewriteUploadStyle = {
  border: '2px dashed #cccccc',
  borderRadius: '4px',
  paddingBottom: "5px",
  paddingTop: "20px",
  textAlign: 'center',
  cursor: 'pointer',
  opacity: '0.7',
  boxShadow: '3px 3px 5px 0px rgba(0,0,0,0.3)',
  maxHeight: '90px',
  overflowY: 'auto',
};

export default BulkUploadPopup;
